import Vue from 'vue';
import Genplan from './Genplan.vue';

Vue.config.productionTip = false;

const mountEl = document.querySelector('#genplan');

new Vue({
  render(h) {
    return h(Genplan, {
      props: { ...mountEl.dataset },
    });
  },
  props: ['data'],
}).$mount('#genplan');
